import React from 'react';
import { ASN_STATUS } from '../constants';

const isShiftModifiable = chassisStatus => {
  return !(
    chassisStatus === ASN_STATUS.PLANNED ||
    chassisStatus === ASN_STATUS.LINE_OUT
  );
};

const deriveShiftBackgroundColor = (chassisStatus, shiftLabel) => {
  let backgroundColor = '#A7A7A7';
  if (isShiftModifiable(chassisStatus)) {
    return backgroundColor;
  }
  switch (shiftLabel) {
    case 'A':
      backgroundColor = '#52A281';
      break;
    case 'B':
      backgroundColor = '#0275A7';
      break;
    case 'C':
      backgroundColor = '#0066CC';
      break;
    case 'G':
      backgroundColor = '#608FC9';
      break;
    default:
      break;
  }
  return backgroundColor;
};

export const renderShift = col => {
  const currentChassisStatus = col.vcStatus || col.status;
  const currentShiftLabel = col.shiftName;

  if (currentShiftLabel)
    return (
      <div
        style={{
          width: '22px',
          height: '22px',
          lineHeight: '22px',
          borderRadius: '5px',
          backgroundColor: deriveShiftBackgroundColor(
            currentChassisStatus,
            currentShiftLabel,
          ),
          color: 'white',
          textAlign: 'center',
          marginTop: '-4px',
          marginLeft: '10px',
        }}
      >
        {currentShiftLabel}
      </div>
    );
  return <div />;
};
